// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"styles_TextArea__26OQe","buttonCheckBox":"styles_buttonCheckBox__qUXRD","CheckboxButton":"styles_CheckboxButton__2En2h"};